
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pomoc",
      function () {
        return require("private-next-pages/pomoc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pomoc"])
      });
    }
  